
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import RadioButton from '@/components/radio-button.vue';
	import PickerDate from '@/components/picker-date.vue';
  import Dialog from '@/components/dialog.vue';
  import logs from './components/logs.vue'
	import {
		handleClipboard
	} from '@/utils/clipboard'
	import {
		nextDay,
		getSearchDate
	} from "@/utils"
  import {
    orderSettleunsettledlist,
    orderSettlerecordlist,
    orderSettlesettleFirstverify,
    orderSettlesettleFirstunsignedOrderDetailList,
    orderSettletransferVerify,
    orderSettleofflineTransfer
  } from "@/api/order"
  
	import {
		providerSelectItem
	} from '@/api/supplier';
  import { getUserInfo } from '@/utils/storage';
  import message from '@/components/message.vue';
  @Component({  
    name: '',
    components: {
      PageFooter,
      RadioButton,
      PickerDate,
      'slz-dialog': Dialog,
      logs,
      'slz-message': message,
    }
  })

  export default class ProductList extends Vue {
		private defaultThumb = 'https://cdn2024.shiwuzone.com/routuanapp/default-thumb.png';
    private radioType = 0
    private radioList = [
      {value:0,label:'结算中'},
      {value:1,label:'已结算'},
      {value:2,label:'已驳回'},
      {value:-1,label:'未结算'},
    ]
    private keywords = ''
    private supplierNameKey = null
    private supplierNameKey2 = null
    private supplierNameKey3 = null
    private supplier:any = []
    private filterTime = ''
    private tablelist:any = []
    private tableloading = false
    private pageSize = 10
    private pageNo = 1
    private total = 0
    private totalUnsettled = 0
    private chooselist:any = []

    private orderNo = ''
    private tablelist2:any = []
    private orderNo2 = ''
    private keywords2 = ''
    private filterTime2 = ''
    private SettleMoneyAll = 0

    private tipsShow = false
    private type = 1
    private message:any = {
      MessageOne:'',
      MessageTwo:'',
      list:[]
    }
    private showTotal = 0
    private first = true
    private numTestShow = false
    private numTestMsg = {
      list2:'',
      list1:''
    }
    private rowmsg:any = {}
    private logsShow = false
    private auditTime = ''
    private failCount = 0
    private remitState = null
    private remitStateList = [
      {value:null,label:'全部'},
      {value:1,label:'打款中'},
      {value:2,label:'打款成功'},
      {value:3,label:'打款失败'},
    ]
    private verifyShow = false
    private offlinehow = false

    private mounted () {
      this.first = true
      this.filterTime = [getSearchDate(1,false)[0],getSearchDate(2,false)[0]].join('/')
      this.filterTime2 = [[this.nowYear(),'01','01'].join('-'),getSearchDate(2,false)[0]].join('/')
      // this.gettablelist()
      // this.gettablelist2()
      this.getSupplierList()
    }
    async activated () {
      this.first = true
      this.tipsShow = false
      // await this.gettablelist2()
      this.changelist()
      this.getSupplierList()
      this.clearselect()
    }



    private nowYear(){
      let date = new Date()
      return date.getFullYear()
    }
    private async confirmVerify(){
      try{
        this.tableloading = true
        let res = await orderSettletransferVerify({
          FinanceOrderSettleRecordId:this.rowmsg.Id
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.changelist()
        }
      }finally{
        this.tableloading = false
      }
    }
    private async confirmOffline(){
      try{
        this.tableloading = true
        let res = await orderSettleofflineTransfer({
          FinanceOrderSettleRecordId:this.rowmsg.Id
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.changelist()
        }
      }finally{
        this.tableloading = false
      }
    }
    private controls(row,type){
      this.rowmsg = row
      if(type==1){
        this.verifyShow = true
      }else{
        this.offlinehow = true
      }
    }
    private orderlogs(row){
      this.rowmsg = row
      this.logsShow = true
    }
    private clearselect(){
      this.$nextTick(()=>{
        if(!this.$refs.table) return
        (this as any).$refs.table.clearSelection()
      })
    }
    private getrowkey(row){
      return row.ProductId + row.SpecValue + row.ProviderId
    }
    // 获取供应商列表
		private async getSupplierList() {
			try {
				const res: any = await providerSelectItem({});
				this.supplier = res.Result.map(v => {
					return {
						value: v.Id,
						label: v.ProviderName
					}
				})
			} catch (e) {
				console.log('supplierList ===>', e);
			}
		}
    private torules(row){
      this.$router.push({
        name:'settleFreight',
        query:{
          Id:row.ProductId,
          Name:encodeURIComponent(row.ProductName),
					Img:encodeURIComponent(row.ImgUrlComplete || this.defaultThumb),
        }
      })
    }
    private get userInfo() {
      return getUserInfo()
    }
    private orderDetails(row,type){
      let data:any = {
        FinanceOrderSettleRecordId:row.Id,
        ProductId:row.ProductId,
        SpecValue:row.SpecValue,
        ProviderId:row.ProviderId,
        FinanceOrderSettleOrderDetailFromPageType:type
      }
      if(this.radioType==-1){
        if(this.filterTime){
          let time = this.filterTime.split('/')
          data.StartTime = time[0]
          data.EndTime = nextDay(time[1],1)
        }
      }else if(this.radioType==1){
        if(this.filterTime2){
          let time = this.filterTime2.split('/')
          data.StartTime = time[0]
          data.EndTime = nextDay(time[1],1)
        }
      }
      this.$router.push({
        path:'orderDetails',
        query:data
      })
    }
    private keepSettle(row){
      let data:any = {
        FinanceOrderSettleRecordId:row.Id,
      }
      if(this.filterTime){
        let time = this.filterTime.split('/')
        data.StartTime = time[0]
        data.EndTime = nextDay(time[1],1)
      }
      this.$router.push({
        path:'settleDetails',
        query:data
      })
      // console.log(SettleState)
    }
    private closetips(){
      this.tipsShow = false
    }
    private copy(e){
      // console.log(this.chooselist)
      let text = `★ 【${this.chooselist[0]?.ProviderName}】截止${getSearchDate(1,false)[1]}未签收的订单\n`
      this.message.list.map(v=>{
        text+=`★商品名称：${v.ProductName}\n`
        v.UnsignedOrderDetailInfoList.map(x=>{
          text+=`${x.ChildOrderNo} ${x.IsDuringSupport?'（售后中）':''}\n`
        })
      })
      handleClipboard(text,e)
    }
    private selectionChange(list){
      this.chooselist = list
    }
    private changePage(e){
      this.pageNo = e
      this.changelist()
    }
    private async gettablelist(){
      let t = this.filterTime.split('/')
      if((new Date(t[1]).getTime()-new Date(t[0]).getTime())/1000/60/60/24 > 90){
        this.$message.error('最多选择跨度90天的日期')
        return
      }
      try{
        this.tableloading = true
        let data:any = {
          Keywords:this.keywords,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize,
          ProviderId:this.supplierNameKey
        }
        if(this.filterTime){
          let time = this.filterTime.split('/')
          data.StartTime = time[0]
          data.EndTime = nextDay(time[1],1)
        }
        let res:any = await orderSettleunsettledlist(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results.map(v=>{
            v.rollTime = v.OpenTime.replace(/-/g,'/').substring(0,10)+'-'+v.TakedownTime.replace(/-/g,'/').substring(0,10)
            return v
          })
          this.totalUnsettled = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private doSearch(){
      this.pageNo = 1
      this.changelist()
      this.clearselect()
    }
    private clearSearch(){
      if(this.radioType==-1){
        this.keywords = ''
        this.supplierNameKey = null
        this.filterTime = [getSearchDate(1,false)[0],getSearchDate(2,false)[0]].join('/')
      }else if(this.radioType==0){
        this.orderNo = ''
        this.supplierNameKey2 = null
      }else{
        this.orderNo2 = ''
        this.keywords2 = ''
        this.supplierNameKey3 = null
        this.filterTime2 = [[this.nowYear(),'01','01'].join('-'),getSearchDate(2,false)[0]].join('/')
        this.auditTime = ''
        this.remitState = null
      }
      this.doSearch()
    }
    private exportfile(){
      let url = location.origin
      if(this.radioType==-1){
        url += '/pc/finance/orderSettle/unsettled/list'
        url += '?Keywords=' + encodeURIComponent(this.keywords)
        url += '&ProviderId=' + (this.supplierNameKey||'')
        if(this.filterTime){
          let time = this.filterTime.split('/')
          url += '&StartTime=' + time[0]
          url += '&EndTime=' + nextDay(time[1],1)
        }
      }else{
        url += '/pc/finance/orderSettle/record/list'
        if(this.radioType==0){
          url += '?BillNo=' + this.orderNo
          url += '&ProviderId=' + (this.supplierNameKey2||'')
        }else{
          url += '?BillNo=' + this.orderNo2
          url += '&ProductInfo=' + encodeURIComponent(this.keywords2)
          url += '&ProviderId=' + (this.supplierNameKey3||'')
          if(this.radioType==1){
            url += '&TransferStatus=' + (this.remitState==null?'':this.remitState)
          }
          if(this.filterTime2){
            let time = this.filterTime2.split('/')
            url += '&StartTime=' + time[0]
            url += '&EndTime=' + nextDay(time[1],1)
          }
          if(this.auditTime){
            let time = this.auditTime.split('/')
            url += '&CheckTimeStartTime=' + time[0]
            url += '&CheckTimeEndTime=' + nextDay(time[1],1)
          }
        }
        url += '&SettleState=' + this.radioType
      }
      window.open(url)
    }
    private async gettablelist2(){
      try{
        this.tableloading = true
        let data:any = {
          BillNo:this.orderNo,
          SettleState:this.first?0:this.radioType,//进页面第一次要查询审核中的列表
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize,
          ProviderId:this.supplierNameKey2
        }
        let res:any = await orderSettlerecordlist(data)
        if(res.IsSuccess){
          this.tablelist2 = res.Result.Results.map(v=>{
            v.SubmitOrderStartTime = v.SubmitOrderStartTime?.substring(0,10)
            v.SubmitOrderEndDate = v.SubmitOrderEndDate?.substring(0,10)
            return v
          })
          this.total = res.Result.Total
          this.showTotal = res.Result.Total
        }
      }finally{
        this.tableloading = false
        this.first = false
      }
    }
    private async gettablelist3(){
      // let t = this.filterTime2.split('/')
      // if((new Date(t[1]).getTime()-new Date(t[0]).getTime())/1000/60/60/24 > 90){
      //   this.$message.error('最多选择跨度90天的日期')
      //   return
      // }
      try{
        this.tableloading = true
        let data:any = {
          ProductInfo:this.keywords2,
          BillNo:this.orderNo2,
          SettleState:this.radioType,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize,
          ProviderId:this.supplierNameKey3,
          TransferStatus:this.radioType==1?this.remitState:null
        }
        if(this.filterTime2){
          let time = this.filterTime2.split('/')
          data.StartTime = time[0]
          data.EndTime = nextDay(time[1],1)
        }
        if(this.auditTime){
          let time = this.auditTime.split('/')
          data.CheckTimeStartTime = time[0]
          data.CheckTimeEndTime = nextDay(time[1],1)
        }
        let res:any = await orderSettlerecordlist(data)
        if(res.IsSuccess){
          this.tablelist2 = res.Result.Results.map(v=>{
            v.SubmitOrderStartTime = v.SubmitOrderStartTime?.substring(0,10)
            v.SubmitOrderEndDate = v.SubmitOrderEndDate?.substring(0,10)
            return v
          })
          this.total = res.Result.Total
          if(this.radioType==1){
            this.SettleMoneyAll = res.Result.SettleMoneyAll
            this.failCount = res.Result.TransferFailureCount
          }
        }
      }finally{
        this.tableloading = false
      }
    }
    private changRadio(e){
      this.pageNo = 1
      this.changelist()
      this.clearselect()
    }
    private changelist(){
      if(this.radioType==-1){
        this.gettablelist()
      }else if(this.radioType==0){
        this.gettablelist2()
      }else{
        this.gettablelist3()
      }
    }
  }
